<template>
  <div class="radio" v-bind="$attrs">
    <slot />
  </div>
</template>
<script>

export default {
  name: 'radio-group',
  props: {
    value: { type: [String, Number] },
    disabled: { type: Boolean },
    name: { type: String, default: '' }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value(newValue) {
      this.$emit('change', newValue)
    }
  }
}
</script>